import { Badge } from '@/components/ui/badge'
import { useTranslation } from 'react-i18next'
import type { TableStatus } from '@/types/api.types'

interface TableStatusBadgeProps {
  status: TableStatus
  className?: string
}

export function TableStatusBadge({ status, className }: TableStatusBadgeProps) {
  const { t } = useTranslation()

  const statusConfig = {
    available: {
      label: t('table.statusAvailable'),
      variant: 'default' as const,
      className: 'bg-green-500 hover:bg-green-600 text-white',
    },
    occupied: {
      label: t('table.statusOccupied'),
      variant: 'destructive' as const,
      className: 'bg-red-500 hover:bg-red-600 text-white',
    },
  }

  const config = statusConfig[status]

  return (
    <Badge variant={config.variant} className={`${config.className} ${className || ''}`}>
      {config.label}
    </Badge>
  )
}
